import { Sparkles } from 'lucide-react';

export const AiPercentageDetectorLogo = ({
  height = 26,
}: {
  height?: number;
}) => {
  return <Sparkles height={height} width={height} />;
};
